export interface StarterTemplate {
    presentationId: string;
    name: string;
    ctaLink: string;
    createdOn?: string;
    categories: string[];
}

export function formatStarterTemplateCategoryLabel(category: string): string {
    // Special cases
    if (category === "hr-training") {
        return "HR/Training";
    }

    return category
        .split("-")
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
}
